/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { SearchVideoResult } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Youtube<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Search
   * @name YoutubeList
   * @request GET:/youtube
   * @secure
   */
  youtubeList = (
    query?: {
      input?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<SearchVideoResult[], any>({
      path: `/youtube`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
